import { useEffect } from "react";
import { createPortal } from "react-dom";

/** Modale rendue dans <body> : jamais tronquée par un conteneur parent, défilement interne garanti. */
export function ModalShell({ children, onClose, size = "max-w-sm", testid = "app-modal" }) {
  useEffect(() => {
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = previous; };
  }, []);

  return createPortal(
    <div data-testid={testid} onClick={onClose}
      className="fixed inset-0 z-[60] bg-black/40 flex items-start justify-center p-4 py-6 overflow-y-auto overscroll-contain">
      <div onClick={(e) => e.stopPropagation()}
        className={`kcard modal-panel p-5 w-full ${size} space-y-3 max-h-[88vh] overflow-y-auto overscroll-contain`}>
        {children}
      </div>
    </div>,
    document.body);
}
